import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NSEquipmentCellModule, NSGridModule } from '@norfolk-southern/accessns-components';

import { ECRRequestsComponent } from '@ruby/modules/ecr/submodules/ecr-requests/components/ecr-requests.component';
import { ECRRequestsContainer } from '@ruby/modules/ecr/submodules/ecr-requests/containers/ecr-requests.container';
import { ECRReferenceCellContainer } from '@ruby/modules/ecr/submodules/ecr-requests/containers/reference-cell/reference-cell.container';
import { ECRRequestsRoutingModule } from '@ruby/modules/ecr/submodules/ecr-requests/ecr-requests-routing.module';
import { ECRRequestsInfoModule } from '@ruby/shared/dialogs/ecr/ecr-requests-info/ecr-requests-info.module';

@NgModule({
  declarations: [ECRRequestsContainer, ECRRequestsComponent, ECRReferenceCellContainer],
  imports: [
    CommonModule,
    ECRRequestsRoutingModule,
    ECRRequestsInfoModule,
    NSEquipmentCellModule,
    NSGridModule
  ],
  exports: [ECRRequestsContainer]
})
export class ECRRequestsModule {}
